<template>
    <header v-clickaway="closeSearch" class="d-flex flex-row align-items-center">
        <router-link class="logo" :to="{ name: 'home' }">
            <img src="@/assets/lh-logo.png">
        </router-link>

        <div class="flex-fill" />

        <div v-show="!isSearchBoxActive" class="search-box">
            <button type="button" class="btn btn-link text-decoration-none text-nowrap" @click.prevent="toggleSearch">
                <span class="mr-4">Поиск</span>
                <i class="search-icon tlm-icon-search" />
                <i class="search-icon-close tlm-icon-times" />
            </button>
        </div>

        <div :class="{'active': isSearchBoxActive}" class="search-input">
            <vue-simple-suggest ref="simpleSuggest" :list="search" display-attribute="name" @select="onSearchSelect">
                <input id="search" placeholder="Начните печатать..." @keydown.esc="toggleSearch">

                <i class="tlm-icon-times" @click="toggleSearch" />

                <template v-if="adminArea" v-slot:suggestion-item="{ suggestion }">
                    <div :key="'suggestionForAdmin'">
                        <template v-if="!suggestion.user_email">{{ suggestion.id }}</template>
                        <template v-else>
                            <span class="font-weight-bold">{{ suggestion.id }}</span>
                            {{ suggestion.user_email }}<span v-if="suggestion.name">, {{ suggestion.name }}</span><span v-if="suggestion.user_first_name && suggestion.user_last_name">, {{ suggestion.user_first_name + ' ' + suggestion.user_last_name }}</span>
                        </template>
                    </div>
                </template>

                <template v-else v-slot:suggestion-item="{ suggestion }">
                    <div :key="'suggestionForUser'">
                        <span class="font-weight-bold">{{ suggestion.id }}</span> {{ suggestion.name }}
                    </div>
                </template>
            </vue-simple-suggest>
        </div>

        <div v-if="companyisLoaded && isLoggedAsAdmin" class="d-none d-sm-block">
            <router-link :to="{ name: 'admin.company', params: { id: company.id }}" class="text-danger">
                <small>Выполнен вход под учеткой</small>&nbsp;<strong>{{ company.name || `Компания #${company.id}` }}</strong>
            </router-link>
        </div>

        <div v-if="companyisLoaded" class="d-none d-lg-block ml-2">
            <router-link :to="{ name: 'recharge' }">{{ company.balance | money }} {{ company.balance_currency | currencySymbol }}</router-link>
        </div>

        <div v-clickaway="hideProfileMenu" :class="{ 'show': isProfileMenuVisible }" class="dropdown d-none d-lg-block ml-lg-4">
            <a href="/" data-toggle="dropdown" class="text-nowrap" @click.prevent="showProfileMenu">
                <span class="mr-3">{{ company.user_email || 'Меню' }}</span> <i class="tlm-icon-account text-muted" />
            </a>

            <div class="dropdown-menu">
                <router-link class="dropdown-item" :to="{ name: 'profile' }">
                    <span @click="hideProfileMenu">
                        <span>Профиль</span>
                    </span>
                </router-link>

                <div class="dropdown-divider" />
                <router-link :to="{ name: 'logout' }" class="dropdown-item"><span>Выйти</span></router-link>
            </div>
        </div>

        <button type="button" class="btn btn-link btn-menu d-block d-lg-none" @click.prevent.stop="$emit('sidebar')">
            <i class="tlm-icon-bars" />
        </button>
    </header>
</template>

<script>
import axios from 'axios'
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css'

export default {
    components: {
        VueSimpleSuggest
    },

    data() {
        return {
            isSearchBoxActive: false,
            isProfileMenuVisible: false
        }
    },

    computed: {
        companyisLoaded() {
            return this.$store.getters['company/isLoaded']
        },

        company() {
            return this.$store.state.company.profile.data
        },

        adminArea() {
            return this.$route.meta && this.$route.meta.adminArea === true
        },

        isLoggedAsAdmin() {
            return this.$store.getters['auth/isLoggedAsAdmin']
        }
    },

    methods: {
        toggleSearch() {
            this.isSearchBoxActive = !this.isSearchBoxActive

            if (this.isSearchBoxActive) {
                this.$nextTick(function () {
                    document.getElementById('search').focus()
                })
            } else {
                this.$refs.simpleSuggest.setText('')
                this.$refs.simpleSuggest.clearSuggestions()
            }
        },

        showProfileMenu() {
            this.isProfileMenuVisible = true
        },

        hideProfileMenu() {
            this.isProfileMenuVisible = false
        },

        async search(value) {
            const url = this.adminArea
                ? 'api/admin/companies?search=' + value + '&full=1'
                : `api/search?q=${value}`

            const response = await axios.get(url)

            return response.data
        },

        onSearchSelect(suggestion) {
            this.adminArea
                ? this.$router.push({ name: 'admin.company', params: { id: suggestion.id } })
                : this.$router.push({ name: 'vm', params: { id: suggestion.id } })

            this.isSearchBoxActive && this.toggleSearch()
        },

        closeSearch() {
            this.isSearchBoxActive && this.toggleSearch()
        }
    }
}
</script>
